import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../../redux/errors.slice"
import { unknownError } from "../../../../utils/handlers/handle-error"
import { showResponseMessage } from "../../../../utils/handlers/show-response-message.ts"
import * as services from "../../api/project-commissions.services"
import { projectSliceName } from "../project.constants.ts"
import { type ProjectCommissionsFilters } from "../project.types.ts"
import type {
  ProjectCommission,
  ProjectCommissionsData
} from "./project-commissions.types.ts"

export const fetchProjectCommissions = createAsyncThunk<
  ProjectCommissionsData,
  ProjectCommissionsFilters & { projectId: string; ordering?: string | null }
>(
  `${projectSliceName}/fetchProjectCommissions`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getProjectCommissions(params)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    return response.data as ProjectCommissionsData
  }
)

export const patchProjectCommission = createAsyncThunk<
  ProjectCommissionsData,
  { projectId: string; data: Partial<ProjectCommission> & { id: string } }
>(
  `${projectSliceName}/patchProjectCommission`,
  async ({ projectId, data }, { dispatch, rejectWithValue }) => {
    const response = await services.patchProjectCommission(projectId, data)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Commission updated successfully.")

    return response.data?.details?.data as ProjectCommissionsData
  }
)
